<template>
      <search-from
        :fields="fields"
        :pagination="pagination"
        @click="onSearch"
      ></search-from>
</template>
<script>
    import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
    import {PaginationMeta} from "../../models/PaginationMeta";
    import SearchFrom from "../base/SearchForm";
    import {SearchField} from "../../services/SearchField";
    import {parseEnum} from "../../shared/utils";
    import {NewsCategory} from "../../models/News/NewsCategory";
    import {News} from "../../models/News/News";

    const NewsRepo = RepositoryFactory.get('news')

    export default {
      name: 'news-search-form',
      components: {
        SearchFrom,
      },
      props: {
        pagination: Object,
        default: new PaginationMeta(),
      },
      data() {
          return {
              fields: [
                new SearchField()
                  .setLabel('Name')
                  .setDescription('Name')
                  .setKey('name')
                  .setType(SearchField.FIELD_TYPES.FIELD_TEXT)
                ,
                new SearchField()
                  .setLabel('Status')
                  .setDescription('Status')
                  .setType(SearchField.FIELD_TYPES.FIELD_SELECT)
                  .setValues(parseEnum(News.STATUS))
                  .setKey('status')
                ,
                new SearchField()
                  .setLabel('Is Action')
                  .setDescription('Is Action?')
                  .setType(SearchField.FIELD_TYPES.FIELD_CHECK_BOX)
                  .setKey('isAction')
                ,
                new SearchField()
                  .setLabel('Categories')
                  .setDescription('Categories')
                  .setType(SearchField.FIELD_TYPES.FIELD_SELECT)
                  .setValues(parseEnum(NewsCategory.CATEGORIES))
                  .setKey('categories')
                ,
              ],
          }
      },
      methods: {
          onSearch(params) {
            this.$emit('clicked', params)
            NewsRepo
              .searchNews(params)
              .then(
                response => (
                  this.$emit('change', response.data)
                )
              )
          },
      },
    }
</script>
